import React from 'react'
import { ButtonWithModal, Image, Link } from 'newComponents'

import './styles.scss'

const WebinarSeriesItems = ({ data }) => {
  const {
    primary: {
      agenda_number: number,
      marketo_form_id: mktoId,
      past_event_: pastEvent,
      webinar_date: date,
      webinar_title: title,
      webinar_content: content
    },
    items
  } = data

  const mktoIdNumber = mktoId?.text
  const dateHtml = date?.html
  const titleHtml = title?.html
  const contentHtml = content?.html
  const numberUpdated = parseInt(number) < 10 ? `0${number}` : number

  const RenderMktoBtn = () => {
    let text = 'Register'
    if (pastEvent) {
      text = 'Get the Recording'
    }

    const modalSubtitleTxt = 'Sign up webinar by providing information'

    return (
      <ButtonWithModal
        buttonText={text}
        modalTitle={title.text}
        formId={mktoIdNumber}
        modalSubtitle={modalSubtitleTxt}
        toggleCheckbox={number}
        addArrow
      />
    )
  }

  return (
    <div data-scrollto={numberUpdated} className="webinar-series-item">
      <div className="webinar-series-item-inner container">
        <div className="webinar-series-item-number">{numberUpdated}</div>
        <div className="webinar-series-item-date" dangerouslySetInnerHTML={{ __html: dateHtml }} />
        <div className="webinar-series-item-content-column-group">
          <div className="webinar-series-item-content-column">
            <div className="webinar-series-item-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />
            <div className="webinar-series-item-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
            <RenderMktoBtn />
          </div>
          <div className="webinar-series-item-speaker-column">
            <h3>Speakers</h3>
            {items.map((speaker) => {
              const {
                speaker_avatar: avatar,
                speaker_company: company,
                speaker_company_url: companyUrl,
                speaker_name: name,
                speaker_position: position
              } = speaker

              return (
                <div key={name.text} className="webinar-series-item-speaker">
                  <div className="webinar-series-item-speaker-image-column">
                    <Image image={avatar.url} />
                  </div>
                  <div className="webinar-series-item-speaker-content-column">
                    <div
                      className="webinar-series-item-speaker-content-title"
                      dangerouslySetInnerHTML={{ __html: name.html }}
                    />
                    <div className="webinar-series-item-speaker-content-position">
                      {position.text}{' '}
                      {company.text && (
                        <span>
                          at <Link to={`${companyUrl.url}`}>{`${company.text}`}</Link>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default WebinarSeriesItems
